import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=789a98eb&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=789a98eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a98eb",
  null
  
)

export default component.exports